import type { Me, UserRole } from '../redux/api/user.api.ts';

/**
 * Determines if a user is authorized based on their assigned roles.
 * @param user - The user object containing role information
 * @param roles - Array of roles required for authorization
 * @returns true if the user has at least one role in the provided roles array, false otherwise
 */
export function isAuthorized(user: Me | undefined, roles: UserRole[]): boolean {
  if (!user?.roles?.length) {
    return false;
  }
  return user.roles.some((role) => roles.includes(role));
}

/**
 * Compares two user identifiers. GUIDs are case-insensitive, but SQL Server renders
 * UNIQUEIDENTIFIER columns in upper case while the Azure AD `oid` claim is lower case,
 * so the two sides of an ownership check never match under a strict comparison.
 * @param a - First user identifier
 * @param b - Second user identifier
 * @returns true if both identifiers are present and refer to the same user
 */
export function isSameUser(
  a: string | number | null | undefined,
  b: string | number | null | undefined
): boolean {
  if (a === null || a === undefined || b === null || b === undefined) {
    return false;
  }
  return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
}
